import cloneDeep from 'lodash/cloneDeep'
import AccountType from '@/constants/user/AccountType'
import File from '@/models-ts/File'
import GigShort from '@/models-ts/gigs/GigShort'
import Skill from '@/models-ts/Skill'
import Avatar from '@/models-ts/user/Avatar'
import Channel from '@/models-ts/user/Channel'
import Education from '@/models-ts/user/Education'
import PortfolioProject from '@/models-ts/user/PortfolioProject'
import PrefferedCurrency from '@/models-ts/user/PrefferedCurrency'
import Review from '@/models-ts/user/Review'
import WorkExperience from '@/models-ts/user/WorkExperience'

export default class FreelancerDetails {
  id: number
  isPretty: boolean
  firstName?: string
  lastName?: string
  fullName?: string
  bannedAt?: string
  avatar: Avatar
  type: AccountType
  avgReview: string
  reputation: number
  completedGigs: number
  completedJobs: number
  website: string
  skills: Array<Skill>
  specialization: string
  cityName: string
  countryName: string
  rate: string
  currencies: Array<PrefferedCurrency>
  bio: string
  channels: Array<Channel>
  workExperience: Array<WorkExperience>
  educations: Array<Education>
  reviews: Array<Review>
  portfolio: Array<PortfolioProject>
  gigs: Array<GigShort>
  cv: Array<File>
  internalCountryId: number | null
  position: string | null

  constructor(data: Partial<FreelancerDetails>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.FreelancerDetails) {
    return new FreelancerDetails({
      id: data.user_id,
      isPretty: data.is_pretty,
      type: data.type,
      avatar: Avatar.fromServer(data.relations.avatar),
      firstName: data.first_name,
      lastName: data.last_name,
      fullName: data.meta?.user?.name || '',
      bannedAt: data.meta?.user?.banned_at || '',
      avgReview: Number(data.avg_reviews || 0).toFixed(2),
      reputation: data.avg_reputation || 0,
      completedGigs: data.meta?.completed?.gigs || 0,
      completedJobs: data.meta?.completed?.jobs || 0,
      website: data.website || '',
      cityName: data.city_name || '',
      countryName: data.country_name || '',
      skills: (data.relations.Skill || []).map(Skill.fromServer),
      specialization: data.specialization || '',
      rate: data.rate || '',
      bio: data.bio || '',
      currencies: (data.relations.Currency || []).map(PrefferedCurrency.getFromSrever).filter(Boolean) as Array<PrefferedCurrency>,
      channels: (data.relations.Channel || []).map(Channel.fromServer),
      workExperience: (data.relations.Experience || []).map(WorkExperience.fromServer),
      educations: (data.relations.Education || []).map(Education.fromServer),
      reviews: (data.meta?.review || []).map(Review.fromServer),
      portfolio: (data.relations.Portfolio || []).map(PortfolioProject.fromServer),
      internalCountryId: data.internal_country_id,
      position: data.position,
      gigs: (data.meta?.gigs || []).map(
        (gig) =>
          new GigShort({
            id: gig.id,
            slug: gig.slug,
            type: gig.type,
            name: gig.name,
            description: gig.description,
            banners: gig.banners,
            skills: gig.skills,
            rate: gig.rate,
            timeType: gig.time_type,
            user_id: gig.user_id,
            userName: data.meta.user?.name || '',
            userType: data.type,
            avatar: data.relations.avatar,
            avgReview: data.avg_reviews || 0,
            userReviews: (data.meta?.review || []).length,
          })
      ),
      cv: (data.relations.Cv || []).map(File.fromServer),
    })
  }
}
